<template>
  <b-row>
    <b-col>
      <cabecalho-repeticao
        titulo="Adicione as informações deste usuário por empresa"
        @apply="adicionarItem"
        @remove="removerItem"
      />
      <b-row>
        <b-col
          cols="6"
          class="pr-0"
        >
          <empresa-select
            v-model="valueInner.empresa"
            :filtro-adicional="filtroAdicional"
            :disabled="camposDesabilitados"
            :label="'Empresa'"
            :title-popover="nomeEmpresa()"
            class="empresa-select"
          />
        </b-col>
        <b-col
          cols="5"
          class="pr-0"
        >
          <validation-provider
            #default="{ errors }"
            :rules="valueInner.empresa && valueInner.empresa.id > 0 ? 'required' : ''"
            :name="`Departamentos${itemAcesso}`"
          >
            <departamento-select
              v-model="valueInner.departamentos"
              :multiple="true"
              :disabled="camposDesabilitados"
              class="departamento-select"
            />
            <small class="text-danger">{{ errors[0] ? 'O campo Departamento é obrigatório' : '' }}</small>
          </validation-provider>
        </b-col>
        <b-col
          cols="auto"
        >
          <b-form-group label="Ativa">
            <b-form-checkbox
              v-model="valueInner.ativa"
              v-b-tooltip.hover
              title="Empresa ativa"
              class="custom-control-primary mt-50"
              style="float:left;"
              name="check-button"
              switch
              @change="inativarUsuarioEmpresa"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="erroEmpresa"
        class="erros"
      >
        <b-col cols="3">
          <small class="text-danger">O campo Empresa é obrigatório</small>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="3"
        >
          <validation-provider
            #default="{ errors }"
            :rules="valueInner.empresa && valueInner.empresa.id > 0 ? 'required' : ''"
            :name="`Função${itemAcesso}`"
          >
            <funcao-select
              v-model="valueInner.funcao"
              :disabled="camposDesabilitados"
              :item-acesso="itemAcesso"
              :require="false"
            />
            <small class="text-danger">{{ errors[0] ? 'O campo Função é obrigatório' : '' }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Data de entrada">
            <data-input
              v-model="valueInner.dataAdmissao"
            />
          </b-form-group>
        </b-col>
        <b-form-group
          label="Integração RH"
          class="col-md-2"
        >
          <b-form-input
            v-model="valueInner.codigoIntegracao"
            :disabled="camposDesabilitados"
          />
        </b-form-group>
        <b-col
          cols="2"
        >
          <b-form-group label="Telefone">
            <b-input-group>
              <masked-input
                ref="telefone"
                v-model="valueInner.telefone"
                :mask="constroiMascaraContato"
                class="form-control"
                :disabled="camposDesabilitados"
              />
              <b-input-group-append>
                <b-button
                  v-b-tooltip.hover
                  :pressed.sync="valueInner.telefoneWhatsApp"
                  title="Telefone possui WhatsApp"
                  :variant="valueInner.telefoneWhatsApp ? 'success' : 'outline-success'"
                  class="whatsapp-btn"
                  :disabled="camposDesabilitados"
                >
                  <feather-icon icon="MessageCircleIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Sócio nessa empresa?">
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Sócio"
            >
              <b-select
                v-model="valueInner.socio"
                :options="[{ value: true, text: 'Sim' }, { value: false, text: 'Não' }]"
                @change="alteracaoSocio($event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="valueInner.socio">
        <b-col cols="4">
          <div style="display: flex;justify-content: space-between;">
            <div>
              <legend class="col-form-label pt-2" />
              <b-form-checkbox
                v-model="valueInner.socioAdministrador"
              >
                Sócio administrador
              </b-form-checkbox>
            </div>
            <div>
              <legend class="col-form-label pt-2" />
              <b-form-checkbox
                v-model="valueInner.responsavelRFB"
                @change="verificaRFB"
              >
                Responsável perante a RFB
              </b-form-checkbox>
            </div>
          </div>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Participação societária (R$)">
            <dinheiro-input
              v-model="valueInner.valorSocietaria"
              :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Participação societária (%)">
            <b-form-input
              v-model="valueInner.porcentagemSocietaria"
              @blur="formataPorcentagem"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Data de saída">
            <data-input
              v-model="valueInner.dataSaida"
              @input="inativarVinculoSaida()"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.icone-acao {
  padding: 0.4rem;
}

.erros {
    margin-top: -1rem;
}

.divisao {
  /* padding-left: 0.23rem; */
  background-color: #c9c9c97d;
}

.empresa-select {
  .v-select {
    .vs__selected-options {
      flex-wrap: nowrap;
      max-width: calc(100% - 25px);
    }

    .vs__selected {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
      overflow: hidden;
    }
  }
}

.departamento-select {
  .vs--disabled {
    .vs__selected {
      background-color: var(--primary);
    }
  }
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import api from '@/app-modulo/comuns/usuario-externo/shared/services/api'

export default {
  name: 'EmpresaUsuarioExterno',
  components: {
    ValidationProvider,
    FuncaoSelect: () => import('@/shared/components/funcao-select/FuncaoSelect.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    camposDesabilitados: {
      type: Boolean,
      default: () => false,
    },
    itemAcesso: {
      type: Number,
      default: () => 0,
    },
    usuarioId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      valueInner: {
        empresa: null,
        funcao: null,
        departamentos: null,
        codigoIntegracao: '',
        dataAdmissao: null,
        socio: false,
        socioAdministrador: null,
        responsavelRFB: null,
        valorSocietaria: null,
        porcentagemSocietaria: '0.00%',
        sobreescrever: false,
        removerVinculo: false,
        dataSaida: null,
      },
      erroEmpresa: false,
      eraSocio: false,
      adicionadoData: false,
    }
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.eraSocio = this.valueInner.socio
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.eraSocio = this.valueInner.socio
    this.aplicaMascaras()
  },
  methods: {
    formataPorcentagem() {
      this.valueInner.porcentagemSocietaria = this.valueInner.porcentagemSocietaria.replace(',', '.')
      const valorSocietariaFormatado = parseFloat(this.valueInner.porcentagemSocietaria, 10)
      if (valorSocietariaFormatado > 100) {
        this.valueInner.porcentagemSocietaria = '100%'
      } else {
        this.valueInner.porcentagemSocietaria = !valorSocietariaFormatado ? `${0}%` : `${valorSocietariaFormatado}%`
      }
    },
    constroiMascaraContato(contato) {
      const contatoSemMascara = contato ? contato.replace(/\D/g, '') : ''

      if (contatoSemMascara.length === 11) {
        return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      }
      return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    },
    removerItem() {
      if ((this.valueInner.empresa && this.valueInner.empresa.id > 0) && (this.usuarioId > 0)) {
        api.existeVinculoSocio(this.valueInner.empresa.id, this.usuarioId)
          .then(payload => {
            if (payload.data) {
              this.$confirmar('Tem certeza que deseja remover esse sócio?', 'Ao confirmar será removido esse sócio também do quadro societário da empresa.', 'question', 'danger')
                .then(result => {
                  if (result.value) {
                    this.$emit('remove', this.valueInner)
                  }
                })
            } else {
              this.$emit('remove', this.valueInner)
            }
          })
      } else {
        this.$emit('remove', this.valueInner)
      }
    },
    adicionarItem() {
      if (this.valida()) {
        this.$emit('novo', this.valueInner)
      }
    },
    valida() {
      let valido = true
      this.erroEmpresa = false

      if (!this.valueInner.empresa) {
        this.erroEmpresa = true
        valido = false
      }
      return valido
    },
    aplicaMascaras() {
      this.valueInner.telefone = (this.valueInner.telefone) ? (this.valueInner.telefone).replace(/[^0-9]/g, '').replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3') : ''
    },
    desabilitarCampos(item) {
      if (!item) {
        this.camposDesabilitados = true
      } else {
        this.camposDesabilitados = false
      }
    },
    nomeEmpresa() {
      if (!this.valueInner.empresa) {
        return ''
      }
      return this.valueInner.empresa.razaoSocial
    },
    inativarUsuarioEmpresa(checked) {
      if (!checked) {
        this.$confirmar('Deseja realmente inativar o vínculo desse usuário com esta empresa?',
          this.valueInner.socio ? 'Ao confirmar, além da inativação, será desvinculado automaticamente esse sócio do cadastro de empresas.'
            : 'Ao confirmar, não serão geradas novas cobranças de documentos para esse vínculo inativo e somente voltará a notificar as cobranças quando efetuado a troca do contato inativo por outro ativo no cadastro de empresas.',
          'question', 'danger')
          .then(result => {
            if (result.value) {
              this.desabilitarCampos()
            } else {
              this.valueInner.ativa = !checked
            }
          })
      }
    },
    verificaRFB(value) {
      if (value) {
        api.existeResponsavelRFB(this.valueInner.empresa.id)
          .then(payload => {
            if (payload.data) {
              this.$confirmar('Deseja marcar esse sócio como responsável perante a RFB?',
                'Ao confirmar, essa ação irá alterar o sócio já existente com essa configuração.',
                'question', 'danger')
                .then(result => {
                  this.valueInner.sobreescrever = !!result.value
                  this.valueInner.responsavelRFB = !!result.value
                })
            }
          })
      } else {
        this.$emit('alterar-responsavel', false)
      }
    },
    alteracaoSocio(value) {
      if (!value && this.usuarioId > 0) {
        this.$confirmar('Tem certeza que deseja alterar essa informação?',
          'Ao confirmar, será removido desse cadastro os campos de preenchimento exclusivo do sócio e será desvinculado esse usuário do quadro societário da empresa.',
          'question', 'danger')
          .then(result => {
            if (result.value) {
              this.valueInner.removerVinculo = true
            } else {
              this.valueInner.socio = true
            }
          })
      } else if (value) {
        this.valueInner.removerVinculo = false
      }
    },
    inativarVinculoSaida() {
      if (this.valueInner.dataSaida && !this.adicionadoData) {
        this.$confirmar('Deseja realmente incluir data de saída para esse sócio?',
          'Ao confirmar, será desvinculado automaticamente esse sócio do cadastro de empresas',
          'question', 'danger')
          .then(result => {
            if (result.value) {
              this.adicionadoData = true
            } else {
              this.valueInner.dataSaida = null
              this.adicionadoData = false
            }
          })
      }
    },
  },
}
</script>
